import { render, staticRenderFns } from "./NavProfilMenu.vue?vue&type=template&id=535799c4&scoped=true&"
import script from "./NavProfilMenu.vue?vue&type=script&lang=js&"
export * from "./NavProfilMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavProfilMenu.vue?vue&type=style&index=0&id=535799c4&prod&lang=scss&scoped=true&"
import style1 from "./NavProfilMenu.vue?vue&type=style&index=1&id=535799c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535799c4",
  null
  
)

export default component.exports